/*
  A redesigned screen's frame inside the app shell: Figma's "Content" column, a
  24px stack on the design font. Sits on the shell's theme, so screens using it
  need no theme of their own.
*/
const Page = ({ className = "", children }) => (
  <div className={`flex w-full min-w-0 flex-col gap-space-24 font-ds text-label-primary ${className}`}>{children}</div>
);

export default Page;
